export enum ChatMessageOwner {
  USER = 'USER',
  BOT = 'BOT'
}

export interface ChatMessage {
  id: string;
  message: string;
  owner: ChatMessageOwner;
  createdAt: string;
  questionId?: string;
  botMetadata?: string;
  inputs?: ChatMessageInput[];
  context?: string;
  messageAttendedByBot?: boolean;
  [key: string]: any;
}

export interface ChatMessageInput {
  type: string;
  text: string;
}

export interface ChatState {
  messages: ChatMessage[];
  isThinking: boolean;
  latestMessage: ChatMessage | null;
  isLoadingOldMessages: boolean;
}

export interface PaginationState {
  currentSkip: number;
  hasMore: boolean;
  pageSize: number;
}

export interface PollingConfig {
  initialInterval: number;
  maxInterval?: number;
}

export interface ChatChannel {
  user: any;
  parent: any;
  parentField: string;
  fetchChats: (payload: any) => Promise<any[]>;
  replyUniqueIdPrefix?: string;
  /** Optional Fibonacci bot-reply poll seed (ms); omitted → ChatService default 1000/1000. */
  pollingSeed?: { interval1: number; interval2: number };
  /** Fired on each empty bot-reply poll (a retry) — consumers log analytics; ChatService stays sink-free. */
  onBotReplyRetry?: () => void;
  /** Fired when the bot reply arrives, with the round-trip since polling began (ms). */
  onBotReplyReceived?: (timeInMillSec: number) => void;
}

export interface ChatQueryParams {
  user: any;
  parent: any;
  parentField: string;
  fetchChats: (payload: any) => Promise<any[]>;
}

export interface FetchChatOptions extends ChatQueryParams {
  limit?: number;
  skip?: number;
  createdAfter?: string;
}
